import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import "./LowPenetrationsDropdown.scss";
import cn from "classnames";
import { cssX, SelectComponent } from "@datassential/platform-ui-lib";

const LowPenetrationDropdown = ({
    includeLowPenetrationItems,
    includeLessTenMenusCount,
    setIncludeOptions,
    onChange,
}) => {
    const [isOpened, setIsOpened] = useState(false);

    const handleOptionChange = (includeLowPenetrationItems, includeLessTenMenusCount) => {
        setIncludeOptions({
            includeLowPenetrationItems,
            includeLessTenMenusCount
        });
        onChange?.();
    };

    const optionsLowPenetration = useMemo(
        () => [
            {
                id: "moreThanOnePercent",
                title: "Items > 1%",
                isActive: !includeLowPenetrationItems && includeLessTenMenusCount,
                onClick: () => handleOptionChange(false, true)
            },
            {
                id: "moreThanTenMenus",
                title: "Items > 10 menus",
                isActive: includeLowPenetrationItems && !includeLessTenMenusCount,
                onClick: () => handleOptionChange(true, false)
            },
            {
                id: "all",
                title: "All items",
                isActive: includeLowPenetrationItems && includeLessTenMenusCount,
                onClick: () => handleOptionChange(true, true)
            },
        ],
        [includeLowPenetrationItems, includeLessTenMenusCount, setIncludeOptions, onChange]
    );

    const title = useMemo(
        () => {
            const activeOption = optionsLowPenetration.find(option => option.isActive);
            return activeOption ? activeOption.title : "Select option";
        },
        [optionsLowPenetration]
    );

    return (
        <div className="low-penetration-btn">
            <SelectComponent
                thumbnailText={title}
                isOpened={isOpened}
                setIsOpened={setIsOpened}

                dropdownProps={{
                    isInPortal: true,
                    isOpened: isOpened,
                    place: "bottom-start",
                    columns: [{
                        id: 'id',
                        title: '',
                        items: [],
                        content: <>
                            {optionsLowPenetration.map(i => (
                                <div
                                    key={i.id}
                                    className={cn(cssX("Dropdown__row"))}
                                >
                                    <div
                                        className={cn(
                                            cssX('Dropdown__item'),
                                            cssX('SelectComponent__item'),
                                            i.isActive && 'active-accessible',
                                        )}
                                        onClick={() => {
                                            i.onClick();
                                            setIsOpened(false);
                                        }}
                                    >
                                        {i.title}
                                    </div>
                                </div>
                            ))}
                        </>,
                    }],
                }}
            />
        </div>
    );
};

export default connect()(LowPenetrationDropdown);